export function secondsToDaysHoursMinutes(totalSeconds: number) {
  if (!totalSeconds) {
    return { days: 0, hours: 0, minutes: 0, seconds: 0 };
  }
  const addZeroIfNeeded = (num: number) => (num < 10 ? `0${num}` : num.toString());

  const days = Math.floor(totalSeconds / (24 * 60 * 60)).toString();
  const hours = addZeroIfNeeded(Math.floor((totalSeconds % (24 * 60 * 60)) / (60 * 60)));
  const minutes = addZeroIfNeeded(Math.floor((totalSeconds % (60 * 60)) / 60));
  const seconds = addZeroIfNeeded(Math.floor(totalSeconds % 60));

  return {
    days,
    hours,
    minutes,
    seconds,
  };
}

export function dateDiffInSeconds(date: Date) {
  return Math.floor((date.getTime() - new Date().getTime()) / 1000);
}
